import React, { useCallback, useEffect, useRef, useState } from "react";
import { get_research } from "../Services/apiRoutes";
import { CircularProgress, Grid, Box, Typography, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import ResearchCard from "./ResearchCard";
import { getCryptoLogoMap } from "../utils/utility";

let coinSymbol = [];

export default function Research() {
    const [loading, setLoading] = useState(true);
    const [iconURL, setIconURL] = useState();
    const [events, setEvents] = useState([]);
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [categories, setCategories] = useState(["Any Category"]);
    const [dates, setDates] = useState(["Any Date"]);
    const [selectedCategory, setSelectedCategory] = useState("Any Category");
    const [selectedDate, setSelectedDate] = useState("Any Date");
    const isFetched = useRef(false);

    const fetchEvents = async () => {
        try {
            const data = await get_research();
            pushCoins(data["data"]);
            getCoinData();
            const sortedEvents = data["data"].sort((a, b) => new Date(b.date) - new Date(a.date));
            setEvents(sortedEvents);
            setFilteredEvents(sortedEvents);
            extractCategoriesAndDates(sortedEvents);
        } catch (error) {
            console.log("in events", error);
        } finally {
            setLoading(false);
        }
    };

    const extractCategoriesAndDates = (data) => {
        const uniqueCategories = new Set(["Any Category"]);
        const uniqueDates = new Set(["Any Date"]);
        data.forEach(item => {
            uniqueCategories.add(item.category);
            const formattedDate = new Date(item.date).toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
            uniqueDates.add(formattedDate);
        });
        setCategories(Array.from(uniqueCategories));
        setDates(Array.from(uniqueDates));
    };

    const handleCategoryChange = (event) => {
        setSelectedCategory(event.target.value);
        filterEvents(event.target.value, selectedDate);
    };

    const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
        filterEvents(selectedCategory, event.target.value);
    };

    const filterEvents = (category, date) => {
        let tempEvents = events;
        if (category && category !== "Any Category") {
            tempEvents = tempEvents.filter(event => event.category === category);
        }
        if (date && date !== "Any Date") {
            const selectedDate = new Date(date);
            tempEvents = tempEvents.filter(event => {
                const eventDate = new Date(event.date);
                return eventDate.getMonth() === selectedDate.getMonth() && eventDate.getFullYear() === selectedDate.getFullYear();
            });
        }
        setFilteredEvents(tempEvents);
    };

    function isMobile() {
        const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const minSize = 450;
        return screenWidth <= minSize;
    }

    const getCoinData = async () => {
        var result = await getCryptoLogoMap(coinSymbol);
        setIconURL(result);
        return result;
    };

    const getCoinList = (data) => {
        let l = (data || "").replace(/'/g, '');
        l = l.replace('[', '');
        l = l.replace(']', '');
        let coinList = l.split(',');

        return coinList;
    };

    const pushCoins = (dataArray) => {
        dataArray.forEach((data) => {
            let coins = getCoinList(data["coinsUsed"]);
            if (coins.length > 0) {
                coinSymbol.push(coins[0]);
            }
        });
    };

    useEffect(() => {
        if (!isFetched.current) {
            fetchEvents();
            isFetched.current = true;
        }
    }, []);

    return (
        <Box maxWidth="1300px" position="relative" margin="auto">
            <Box display="flex" justifyContent="center" alignItems={"center"} sx={{ position: "relative" }}>
                <Typography sx={{ fontWeight: "bold", textAlign: "center", marginTop: "10px", marginBottom: "30px" }} variant="h4">
                    Auro Research
                </Typography>
            </Box>
            <Box display="flex" justifyContent="end" alignItems={"center"} sx={{ marginBottom: "20px" }}>
                <FormControl variant="outlined" sx={{ minWidth: 120, marginRight: "10px" }}>
                    {/* <InputLabel>Category</InputLabel> */}
                    <Select value={selectedCategory} onChange={handleCategoryChange}>
                        {categories.map((category, index) => (
                            <MenuItem key={index} value={category}>
                                {category}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl variant="outlined" sx={{ minWidth: 120 }}>
                    {/* <InputLabel>Date</InputLabel> */}
                    <Select value={selectedDate} onChange={handleDateChange}>
                        {dates.map((date, index) => (
                            <MenuItem key={index} value={date}>
                                {date}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
            <div style={{ minHeight: "100px", marginTop: "40px", display: "flex" }}>
    {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "50px", marginLeft: "auto", marginRight: "auto" }}>
            <CircularProgress />
        </div>
    ) : filteredEvents.length === 0 ? (
        <Typography variant="h6" align="center" sx={{ width: "100%", marginTop: "20px" }}>
            No research found
        </Typography>
    ) : (
        <Grid container spacing={4}>
            {filteredEvents.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                    <ResearchCard
                        author={item.author}
                        url={item.url}
                        image={item.image_url}
                        title={item.title}
                        coinsUsed={getCoinList(item.coinsUsed).length > 0 ? getCoinList(item.coinsUsed)[0] : ""}
                        icons={iconURL}
                        date={item.date}
                    />
                </Grid>
            ))}
        </Grid>
    )}
</div>
        </Box>
    );
}
